import React from 'react';

class FasRtic_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Data Sheet - fas-rtic';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Ffiber%2Fnap-pro.pdf?alt=media&token=6d1c5e19-cf67-4133-af1f-67a46124f243';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FasRtic_pdf